module.exports = __webpack_public_path__ + "static/media/img_snake_flex_top_left.cb1d5745.svg";